import React from 'react'
import { createUseStyles } from 'react-jss'
import InputLabel from './InputLabel'
import LoginButton from './LoginButton'

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '500px',
        alignItems: 'center',
        justifyContent: 'center'
    }
})

const LoginForm = () => {
    const styles = useStyles();
    return (
    <div className={styles.container}>
        <InputLabel label="Username or Email" type="text" name="user[email]" />
        <InputLabel label="Password" type="password" name="user[password]" />
    </div>
    );
}

export default LoginForm